import React from "react";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { useAppSelector } from "../../../shared/hooks/sharedHooks";
import { CustomerBuyerInventoryState, FiltersGroupedStockItemQuery } from "../../shared/models/customerBuyerStockItemsModels";
import { country, CountryCode } from "../../../shared/models/countryModels";
import MultipleSelectFilter from "../../shared/components/MultipleSelectFilter";
import { changeProductFiltersQuery } from "../customerBuyerInventorySlice";
import useTranslation from "../../../shared/hooks/useTranslation";

const Filters = () => {
  const { filters, filtersQuery } = useAppSelector<CustomerBuyerInventoryState>(
    (state: any) => state.customerBuyerInventory);
  const dispatch = useDispatch();
  const { translate } = useTranslation("marketplace");
  const { translate: tCommon } = useTranslation("common");

  const handleFilterChange = (newFiltersQuery: FiltersGroupedStockItemQuery) => {
    dispatch(changeProductFiltersQuery(newFiltersQuery));
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <Box className="flex flex-col gap-2">
      <MultipleSelectFilter
        parameters={filters.countries}
        title={translate("supplierLocation")}
        renderParameterName={parameter => country(parameter.id as CountryCode)?.name}
        onChange={(values) => handleFilterChange({ ...filtersQuery, countryIds: values as number[] })}
      />
      <MultipleSelectFilter
        parameters={filters.manufacturers}
        title={tCommon("brand")}
        onChange={(values) => handleFilterChange({ ...filtersQuery, manufacturerIds: values as string[] })}
      />
      <MultipleSelectFilter
        parameters={filters.categories}
        title={translate("itemCategory")}
        onChange={(values) => handleFilterChange({ ...filtersQuery, categoryIds: values as string[] })}
      />
      <MultipleSelectFilter
        parameters={filters.conditions}
        title={tCommon("condition")}
        onChange={(values) => handleFilterChange({ ...filtersQuery, conditionCodes: values as number[] })}
      />
    </Box>
  );
};
export default Filters;